export default {"src":"/_next/static/media/secure-facility.d737196d.svg","height":448,"width":500};